import { baseUrl } from '../httpService/API';
import { hMacAjax as fetch } from '../httpService';
let orgUrl = baseUrl + '/apaas-system-service';
export let url = {
    // 组织树
    orgTreeListByName: `${orgUrl}/organization/v1/tree`, //组织树列表
    // 获取自主注册配置的组织列表
    improveOrgList: `${baseUrl}/grt-student-service/open/student/v1/student-invite/org/list`,
    getImproveOrgListUrl: `${baseUrl}/grt-user-center-service/open/org`
};

//通过组织名称组织树列表
export async function handleOrgTreeListByName(data) {
    return fetch.get(url.orgTreeListByName, { ...data });
}

//获取自主注册配置的组织列表
export async function handleImproveOrgList() {
    return fetch.get(url.improveOrgList);
}
